// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUpdateEncryptedExternalBankAccountDto
 */
export interface IUpdateEncryptedExternalBankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof IUpdateEncryptedExternalBankAccountDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdateEncryptedExternalBankAccountDto
     */
    routing_transit_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdateEncryptedExternalBankAccountDto
     */
    account_category?: IUpdateEncryptedExternalBankAccountDtoAccountCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof IUpdateEncryptedExternalBankAccountDto
     */
    external_identifier?: string;
    /**
     * Should be encrypted with RSAES_OAEP_SHA_1 algorithm and encoded in base64 format
     * @type {string}
     * @memberof IUpdateEncryptedExternalBankAccountDto
     */
    number?: string;
}

/**
* @export
* @enum {string}
*/
export enum IUpdateEncryptedExternalBankAccountDtoAccountCategoryEnum {
    CHECKING = 'CHECKING',
    SAVING = 'SAVING',
    NONE = 'NONE'
}


/**
 * Check if a given object implements the IUpdateEncryptedExternalBankAccountDto interface.
 */
export function instanceOfIUpdateEncryptedExternalBankAccountDto(value: object): value is IUpdateEncryptedExternalBankAccountDto {
    return true;
}

export function IUpdateEncryptedExternalBankAccountDtoFromJSON(json: any): IUpdateEncryptedExternalBankAccountDto {
    return IUpdateEncryptedExternalBankAccountDtoFromJSONTyped(json, false);
}

export function IUpdateEncryptedExternalBankAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUpdateEncryptedExternalBankAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'routing_transit_number': json['routing_transit_number'] == null ? undefined : json['routing_transit_number'],
        'account_category': json['account_category'] == null ? undefined : json['account_category'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'number': json['number'] == null ? undefined : json['number'],
    };
}

export function IUpdateEncryptedExternalBankAccountDtoToJSON(json: any): IUpdateEncryptedExternalBankAccountDto {
    return IUpdateEncryptedExternalBankAccountDtoToJSONTyped(json, false);
}

export function IUpdateEncryptedExternalBankAccountDtoToJSONTyped(value?: IUpdateEncryptedExternalBankAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'routing_transit_number': value['routing_transit_number'],
        'account_category': value['account_category'],
        'external_identifier': value['external_identifier'],
        'number': value['number'],
    };
}

